import { render } from "./ClientLayout.vue?vue&type=template&id=49f0f172&scoped=true"
import script from "./ClientLayout.vue?vue&type=script&lang=js"
export * from "./ClientLayout.vue?vue&type=script&lang=js"

import "./ClientLayout.vue?vue&type=style&index=0&id=49f0f172&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f0f172"]])

export default __exports__